// extracted by css-extract-rspack-plugin
export default {"filterIcon":"filterIcon-LL8hOF"};